import MojitoCore from 'mojito/core';
import CountryOrSportIconImpl from './country-or-sport-icon.js';
import PropTypes from 'prop-types';

const { UIView } = MojitoCore.Presentation;

/**
 * `CountryOrSportIcon` is a component used to render country flag or sport icon if flag is not available.
 *
 * @class CountryOrSportIcon
 * @memberof Mojito.Modules
 */

/**
 * `CountryOrSportIcon` component prop types.
 *
 * @property {string} sportId - ID of the sport.
 * @property {string} countryCode - Country code value.
 * @property {string} countryName - Country name value.
 * @property {string} iconUrl - Direct participant icon URL from the feed.
 *
 * @memberof Mojito.Modules.CountryOrSportIcon
 */
const propTypes = {
    sportId: PropTypes.string,
    countryCode: PropTypes.string,
    countryName: PropTypes.string,
    iconUrl: PropTypes.string,
};

export default UIView('CountryOrSportIcon', CountryOrSportIconImpl, propTypes);
